import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../constants';
import { SubNav } from '../SubNav/att';
import UserInfo from '../../containers/UserInfo';
import {
  getPrettyPlanCarrier,
  getSubStatus,
  needToShowPlanCarrier,
} from 'helpers/subs';
import EditableRow from 'components/EditableRow';
import { prettyKey } from 'helpers/formatters';
import ToggleLockedPlan from 'components/ToggleLockedPlan/att';

export default ({
  sub,
  subId,
  userId,
  contracts,
  isAdmin,
  handleUpdateField,
  upcomingPlanDetails,
}) => {
  const subStatus = getSubStatus(sub);
  const isNew = subStatus === 'new';
  const isExpired = subStatus === 'expired';
  const upcomingPlanInfo = upcomingPlanDetails?.plan_info;
  const showImsi = sub?.imsi !== undefined;
  const showLocationOfSim = sub?.location_of_sim !== undefined;
  const showStreamingLimitationFilter =
    sub?.streaming_limitation_filter !== undefined;
  return (
    <div className="Sub">
      <div className="flex-justify-space-between">
        <h1>AT&amp;T Subscription details</h1>
        <div>
          {sub.att_status === 'port_confirmed' ||
          sub.att_status === 'port_completed' ? (
            <div>
              <Link
                to={`/att/subscriptions/${sub.id}/confirm-switch-to-sprint`}
              >
                Confirm switch to Sprint
              </Link>
            </div>
          ) : null}
          <div>
            <Link
              to={`/users/${userId}/purchases?subscription=${subId}&subCarrier=att`}
            >
              Subscription purchases
            </Link>
          </div>
        </div>
      </div>
      <SubNav sub={sub} backToSub={false} />
      <table className="table">
        <tbody>
          <tr>
            <td>ID</td>
            <td>{sub.id}</td>
            <td></td>
          </tr>
          <tr>
            <td>User Profile ID</td>
            <td>{sub.user_profile}</td>
            <td></td>
          </tr>
          <EditableRow
            name="first_name"
            label={prettyKey('first_name')}
            value={sub.first_name}
            type="input"
            save={handleUpdateField}
            thirdRowWidth="255px"
          />
          <EditableRow
            name="last_name"
            label={prettyKey('last_name')}
            value={sub.last_name}
            type="input"
            save={handleUpdateField}
            thirdRowWidth="255px"
          />
          <tr>
            <td>MDN</td>
            <td>{sub.mdn}</td>
            <td>
              {sub.att_status === 'new' && (
                <Link to={`/att/subscriptions/${subId}/activate`}>
                  Get a new number{' '}
                </Link>
              )}
            </td>
          </tr>
          {showImsi && (
            <tr>
              <td>IMSI</td>
              <td>{sub.imsi}</td>
              <td></td>
            </tr>
          )}
          {showLocationOfSim && (
            <tr>
              <td>Location Of Sim</td>
              <td>{sub.location_of_sim}</td>
              <td></td>
            </tr>
          )}
          {showStreamingLimitationFilter && (
            <tr>
              <td>Streaming Limitation Filter</td>
              <td>{sub.streaming_limitation_filter}</td>
              <td></td>
            </tr>
          )}
          <tr>
            <td>Device ID</td>
            <td>{sub.device_id}</td>
            <td>
              {!isExpired && (
                <Link to={`/att/subscriptions/${subId}/update-device`}>
                  Update
                </Link>
              )}
            </td>
          </tr>
          <tr>
            <td>ICC ID</td>
            <td>{sub.icc_id}</td>
            <td>
              {!isExpired && (
                <Link to={`/att/subscriptions/${subId}/update-device`}>
                  Update
                </Link>
              )}
            </td>
          </tr>
          <tr>
            <td>AT&T Status</td>
            <td>
              {sub.att_status}
              {sub.corruption_type === 'not_expired_on_att' && (
                <span className="red-text">
                  <span style={{ fontSize: '18px' }}> X</span> being expired
                </span>
              )}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Effective Date</td>
            <td>
              {sub.effective_date
                ? moment(sub.effective_date).format(DATE_TIME_FORMAT)
                : sub.effective_date}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Expiry Date</td>
            <td>
              {sub.expiry_date
                ? moment(sub.expiry_date).format(DATE_TIME_FORMAT)
                : sub.expiry_date}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Expiry Type</td>
            <td>{sub.expiry_type}</td>
            <td></td>
          </tr>
          <tr>
            <td>PIN</td>
            <td>{sub.pin}</td>
            <td></td>
          </tr>
          <tr>
            <td>Activation Type</td>
            <td>{sub.activation_type}</td>
            <td></td>
          </tr>
          <tr>
            <td>Suspension Type</td>
            <td>{sub.suspension_type}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              Plan{' '}
              {sub.plan_locked && <span className="text-danger">(Locked)</span>}
            </td>
            <td>
              {sub.plan && (
                <span>
                  {needToShowPlanCarrier(sub, sub?.plan?.plan_carrier) &&
                    `${getPrettyPlanCarrier(sub?.plan?.plan_carrier)} `}
                  {sub.plan.name}
                  {' - '}${sub.plan.price}
                  {' | '}
                  Data available: {sub.plan.data_available}MB
                  {' | '}
                  Type: {sub.plan.plan_type && sub.plan.plan_type.toString()}
                </span>
              )}
            </td>
            <td>
              {!isExpired && (
                <Link to={`/att/subscriptions/${subId}/update-plan`}>
                  Update
                </Link>
              )}
              {!isExpired && <ToggleLockedPlan sub={sub} />}
            </td>
          </tr>
          <tr>
            <td>Upcoming Plan</td>
            <td>
              {upcomingPlanInfo && (
                <span>
                  {needToShowPlanCarrier(sub, upcomingPlanInfo.plan_carrier) &&
                    `${getPrettyPlanCarrier(upcomingPlanInfo.plan_carrier)} `}
                  {upcomingPlanInfo.name}
                  {' - '}${upcomingPlanInfo.price}
                  {' | '}
                  Data available: {upcomingPlanInfo.data_available}MB
                  {' | '}
                  Type:{' '}
                  {upcomingPlanInfo.plan_type &&
                    upcomingPlanInfo.plan_type.toString()}
                </span>
              )}
            </td>
            <td>
              {!isExpired && !isNew && (
                <Link to={`/att/subscriptions/${subId}/upcoming-plan`}>
                  Update
                </Link>
              )}
            </td>
          </tr>
          <tr>
            <td>Agent ID</td>
            <td>{sub.agent_id}</td>
            <td></td>
          </tr>
          <tr>
            <td>Agent Name</td>
            <td>{sub.agent_name}</td>
            <td></td>
          </tr>
          <tr>
            <td>Device Status</td>
            <td>{sub.device_status}</td>
            <td></td>
          </tr>
          <tr>
            <td>MSID</td>
            <td>{sub.msid}</td>
            <td></td>
          </tr>
          <tr>
            <td className={cn({ 'text-danger': sub.deleted })}>Deleted</td>
            <td className={cn({ 'text-danger': sub.deleted })}>
              {String(sub.deleted)}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Device Protection Contracts</td>
            <td>
              {contracts &&
                contracts.map((contract) => {
                  return (
                    <Link
                      className="mar-r"
                      key={contract.id}
                      to={`/device-protection/contracts/${contract.id}/view`}
                    >
                      ID: {contract.id}
                    </Link>
                  );
                })}
            </td>
            <td>
              {!isExpired && (
                <Link
                  to={`/att/subscriptions/${subId}/contracts/create-contract`}
                >
                  Create New Contract
                </Link>
              )}
            </td>
          </tr>
          <tr>
            <td>Created By</td>
            <td>
              <UserInfo userId={sub.created_by} type="nameIdRole" />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>SMS Notifications</td>
            <td>{String(sub.sms_notifications)}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
